import { version, MessageBox } from 'element-ui'
import * as filters from '../utils/filter'
import directives from '../directives'
import { CHARTS_THEME, PAGINATION } from '../config'
import { http } from '../utils/http'
import rules from '../utils/rules'
import pattern from '../utils/pattern'
import { filterParams, logReport } from '../utils/common'
import bus from '../utils/bus'
import log from '../utils/custom-log'
import { createReportFormComponents } from './kye-report-form/install'
import { $utils } from '../utils'
// 主题色定义
import { sysColor } from '../config/color'

import '../assets/scss/element-variables.scss'
import '../assets/scss/app.scss'

// QueryTable
import FormItemMenu from './query-table/form-item-menu'
import QueryForm from './query-table/query-form'
import QueryTable from './query-table/index'
import SearchPager from './query-table/search-pager'
import TableList from './query-table/table-list'
import Table2Wrap from './query-table/table2/kye-table2-wrap'
import ToolList from './query-table/tool-list'

// 重写 el 组件
// 重写组件需在组件public仓库组件注册前
import ELDatePicker from './el-date-picker/index.js'
import ELTimepicker from './el-date-picker/src/picker/time-picker'
import ELPagination from './el-pagination/index'
import ELTable from './el-table/index'
import ELTableColumn from './el-table/src/table-column'
import ELTabs from './el-tabs/index'
import ELTabPane from './el-tabs/src/tab-pane'
import ElCascader from './el-cascader'
import ELDialog from './el-dialog'

// KYE组件库
import KyeAreaRemote from './kye-area-remote'
import KyeAutocomplete from './kye-autocomplete'
import KyeBadge from './kye-badge/index.vue'
import KyeButton from './kye-button'
import kyeCanvasTable from './kye-canvas-table'
import KyeCard from './kye-card'
import KyeCascader from './kye-cascader'
import KyeCheckbox from './kye-checkbox'
import KyeCheckboxButton from './kye-checkbox-button'
import KyeCheckboxGroup from './kye-checkbox-group'
import KyeCol from './kye-col'
import KyeDatePicker from './kye-date-picker'
import KyeDataRange from './kye-date-picker/date-range'
import KyeDecrypt from './kye-decrypt'
import KyeDialog from './kye-dialog'
import KyeDropdown from './kye-dropdown'
import KyeDropdownItem from './kye-dropdown-item'
import KyeDropdownMenu from './kye-dropdown-menu'
import KyeDetailTable from './kye-edit-table/detail'
import KyeEditTable from './kye-edit-table'
import KyeEditorNew from './kye-editor-new'
import KyeExpandPage from './kye-expand-page'
import KyeField from './kye-field'
import KyeFieldComment from './kye-field-comment'
import KyeForm from './kye-form'
import KyeFormItem from './kye-form-item'
import KyeImage from './kye-image'
import KyeInput from './kye-input'
import KyeInputNumber from './kye-input-number'
import KyeNumber from './kye-number/index'
import KyeOption from './kye-option'
import KyePopover from './kye-popover'
import KyePreview from './kye-preview'
import KyePreviewList from './kye-preview/component/file-list.vue'
import KyeRadio from './kye-radio'
import KyeRadioGroup from './kye-radio-group'
import KyeRow from './kye-row'
import KyeSearchTips from './kye-search-tips'
import KyeSelect from './kye-select/index.vue'
import KyeStep from './kye-step'
import KyeSteps from './kye-steps'
import KyePagination from './kye-pagination'
import KyeTable from './kye-table'
import KyeTextarea from './kye-textarea'
import KyeTableColumn from './kye-table-column'
import KyeTabs from './kye-tabs'
import KyeTabPane from './kye-tab-pane'
import KyeTag from './kye-tag'
import KyeTimePicker from './kye-time-picker/index.vue'
import KyeTimeSelect from './kye-time-select'
import KyeUpload from './kye-upload'
import KyeFieldHelp from './kye-field-help'
import KyeFieldCall from './kye-field-call'
import KyeTable2 from './kye-table2'
import KyeDatePicker2 from './kye-date-picker2'
import KyeDatePicker3 from './kye-date-picker3'
import openPreview from '@/public/components/kye-preview/preview'
// 金额输入与展示
import kyeInputMoney from './kye-input-money'

// 金额
import KyeFieldMoney from './kye-field-money'

// 单选组织
import KyeDept from './kye-dept'
import KyeDeptSelect from './kye-dept/dept-select.js'

// 虚拟列表
import KyeVirtualList from './kye-virtual-list'

// kye五级地址组件
import KyeAreaSelect from './kye-area-select'

// 导入
import KyeDataImport from './kye-data-import'
// 导出
import KyeDataExport from './kye-data-export'

// KYE指导组件
import createKyeGuide from './kye-guide/kye-guide.js'

// kye抽屉组件
import KyeDrawer from './kye-drawer'

// 组织树多选组件
import KyeDeptMultiple from './kye-dept-multiple/kye-dept-multiple.vue'

// 空状态
import KyeEmpty from './kye-empty'

// 数据统计组件
import KyeDataStatistic from './kye-data-statistic'
// 地址查询组件
import KyeAddress from './kye-address'

// 地址远程下拉搜索组件
import KyeAddressSearch from './kye-address-search'
// 区域地址单选
import KyeArea from './kye-area/index.js'
// 员工搜索组件
import KyeEmployee from './kye-employee'
// el-image
import ElImage from './el-image'

// mixins
import ComponentLogMixins from '../mixins/component-report'
import moduleMountedReport from '../mixins/module-mounted-report'

const components = [
  ELDatePicker,
  ELTimepicker,
  ElImage,
  FormItemMenu,
  QueryForm,
  QueryTable,
  SearchPager,
  TableList,
  Table2Wrap,
  ToolList,
  ELPagination,
  ELTable,
  ELTableColumn,
  ELTabs,
  ELTabPane,
  ElCascader,
  ELDialog,
  KyeAreaRemote,
  KyeAddress,
  KyeAddressSearch,
  KyeAutocomplete,
  KyeBadge,
  KyeButton,
  kyeCanvasTable,
  KyeCard,
  KyeCascader,
  KyeCheckbox,
  KyeCheckboxButton,
  KyeCheckboxGroup,
  KyeCol,
  KyeDatePicker,
  KyeDataRange,
  KyeDecrypt,
  KyeDialog,
  KyeDropdown,
  KyeDropdownItem,
  KyeDropdownMenu,
  KyeEditTable,
  KyeEditorNew,
  KyeExpandPage,
  KyeDetailTable,
  KyeField,
  KyeFieldComment,
  KyeForm,
  KyeFormItem,
  KyeImage,
  KyeInput,
  KyeInputNumber,
  kyeInputMoney,
  KyeNumber,
  KyeOption,
  KyePopover,
  KyePreview,
  KyePreviewList,
  KyeRadio,
  KyeRadioGroup,
  KyeRow,
  KyeSearchTips,
  KyeEmployee,
  KyeSelect,
  KyeStep,
  KyeSteps,
  KyePagination,
  KyeTable,
  KyeTextarea,
  KyeTableColumn,
  KyeTabs,
  KyeTabPane,
  KyeTag,
  KyeTimePicker,
  KyeTimeSelect,
  KyeUpload,
  KyeDept,
  KyeDeptSelect,
  KyeVirtualList,
  KyeTable2,
  KyeDatePicker2,
  KyeDatePicker3,
  KyeFieldHelp,
  KyeFieldCall,
  KyeFieldMoney,
  KyeAreaSelect,
  KyeDataImport,
  KyeDataExport,
  KyeDeptMultiple,
  KyeEmpty,
  KyeDrawer,
  KyeDataStatistic,
  KyeArea,
  ...createReportFormComponents()
]

const setPrototype = (Vue) => {
  Vue.prototype.$bus = bus
  Vue.prototype.$rule = rules
  Vue.prototype.$reg = pattern
  Vue.prototype.$http = http
  Vue.prototype.$chartsTheme = CHARTS_THEME
  Vue.prototype.$pagination = PAGINATION
  Vue.prototype.$diff = filterParams
  Vue.prototype.$openPreview = openPreview
  Vue.prototype.$log = log
  Vue.prototype.$logReport = logReport
  // 工具集合
  Vue.prototype.$utils = $utils
  // 主题色
  Vue.prototype.$sysColor = sysColor

  // options: {tag, module, cb, index}
  Vue.prototype.$refreshMainQueryTable = function (options) {
    if (!options) {
      options = { tag: this.$route.meta.tag }
      this.$store.commit('queryTable/refresh', options)
    } else if (options.module) {
      options.tag = options.tag || this.$route.meta.tag
      this.$store.commit('queryTable/refresh', options)
    }
  }

  Vue.prototype.$filter = Object.keys(filters).reduce((s, key) => {
    Vue.filter(key, filters[key])
    s[key] = filters[key]
    return s
  }, {})

  Vue.prototype.$createKyeGuide = createKyeGuide

  Vue.mixin(ComponentLogMixins)
  Vue.mixin(moduleMountedReport)

  Object.assign(Vue.prototype.$ELEMENT, { version })
}

const setDirective = (Vue) => {
  Object.keys(directives).forEach(v => Vue.directive(v, directives[v]))
}

const install = function (Vue) {
  window.$version = { vue: Vue.version, ele: version }
  components.filter(v => typeof v !== 'function').forEach(v => Vue.component(v.name, v))
  setPrototype(Vue)
  setDirective(Vue)
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

// 自定义 MessageBox 默认配置
MessageBox.setDefaults({
  type: 'warning',
  showClose: true,
  closeOnClickModal: false,
  closeOnPressEscape: false
})

export default install



// WEBPACK FOOTER //
// ./src/public/components/index.js